import styled from '@emotion/styled'
import { Typography, Alert, Box } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

// GoalsPageEmptyState
export const GoalsPageEmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #e8f3ff;
  border-radius: 8px;
  margin-top: 16px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`

export const GoalsEmptyStateHeader = styled(Typography)`
  ${typography.up3.regularSerif}
  margin: 0;
  padding: 24px 16px 16px 24px;
  color: ${colors.copy.headerDark};
  font-weight: 500;
`

export const GoalsEmptyStateAlert = styled(Alert)`
  background-color: ${colors.background.primaryBackground};
  color: ${colors.copy.paragraphDark};
  margin: 0 20px;
  padding: 16px 24px;
  border-radius: 0;
  border-top: none;
  box-shadow: none;
  margin-bottom: 16px;

  & .MuiAlert-icon {
    color: ${colors.copy.paragraphDark};
    align-self: flex-start;
    margin-top: 3px;
    margin-right: 12px;
  }

  & .MuiAlert-message {
    padding: 0;
  }
`

export const GoalsEmptyStateText = styled(Typography)`
  ${typography.baseline.regularSans}
  color: ${colors.copy.paragraphDark};
  margin-top: 0;
  margin-bottom: 0;

  &:not(:last-child) {
    margin-bottom: 12px;
  }
`

export const GoalsRightColumn = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 48px 24px;
  width: 100%;
`

export const TrendLineIcon = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${colors.background.primaryBackground};
  border-radius: 60px;
  padding: 16px;
  color: ${colors.interactive.primaryEnabled};
  margin-bottom: 24px;

  svg {
    font-size: 64px;
    transform: rotate(10deg);
  }
`

export const AddGoalButtonWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const HeroText = styled(Typography)`
  ${typography.up3.regularSans}
  padding-top: 24px;
`

export const GoalCreationGuide = styled.div`
  ${typography.baseline.regularSans}
  padding: 24px 0;
`

export const TemplatesCallToActionText = styled(Typography)`
  ${typography.up3.regularSans}
`
export const TemplatesCallToAction = styled.div`
  ${typography.baseline.regularSans}
  padding: 24px 0;
`

export const Anchor = styled.a`
  color: ${colors.interactive.primaryEnabled};
`

// GoalPageEmptyState
export const GoalPageEmptyStateContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 60px 24px;
`

export const Header = styled(Typography)`
  ${typography.up3.regularSans}
  padding-bottom: 20px;
`

export const ContentContainer = styled.div`
  ${typography.baseline.regularSans}
  padding: 40px 0;
`

// GoalSectionEmptyState
export const GoalSectionEmptyStateContainer = styled.div<{ simple?: boolean }>`
  align-items: center;
  background-color: ${({ simple }) =>
    simple ? 'none' : colors.background.secondaryBackground};
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  padding: 16px 0;
  width: 100%;
`

export const IconContainer = styled.span`
  align-items: center;
  display: flex;
  color: ${colors.interactive.disabledLight};
`

export const Message = styled(Typography)`
  ${typography.baseline.regularSans}
`
